import React from 'react'
import { Loader } from 'semantic-ui-react'

export const LoaderContainer = () => (
  <div style={{ position: 'relative', marginBottom: '-7rem', marginTop: '1rem' }}>
    <Loader active />
  </div>
)
